<template>
	<RouterView />
</template>

<script>
export default {
	name: 'PreviewView'
}
</script>
